import React, { useContext, useState, useReducer, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios"

import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import AddIcon from '@mui/icons-material/Add';
import Dialog from "@material-ui/core/Dialog";
import { DialogContent } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CircularProgress from "@material-ui/core/CircularProgress";
import {
    Collapse,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Button, makeStyles
} from '@material-ui/core'

import { dataFetchReducer } from "../../../Utils/requestUtils";
import AuthContext from "../../../../context/auth-context";
import ChangesPreviewDialog from "./ChangesPreviewDialog";
import ClearIcon from '@material-ui/icons/Clear';
import ActiveRuleBatchChangeDialog from "./ActiveRuleBatchChangeDialog";


const useStyles = makeStyles({
    root: {
        color: '#0b1f82',
        '&$checked': {
            color: '#0b1f82',
        },
    },
    checked: {},
});

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

function NewRulePieceDialog(props) {

    const classes = useStyles();

    let { setRulePieceDefinition, rule_piece_key, companies, handleRulePiece, events, rulePieceErrorCode, setRulePieceErrorCode } = props

    let user_data = useContext(AuthContext).user_data;
    let roles = user_data.roles

    const { t } = useTranslation();

    const history = useHistory()
    const handleDialogClose = () => {
        history.push("/rule-pieces-inbox")
    }

    const steps = [
        'rule_piece_initial_data',
        'rule_piece_company_events_selection',
        'rule_piece_validation'
    ]
    const [maxWidthEnum, setMaxWidthEnum] = useState(events ? "lg" : "xs")

    const [rulePieceName, setRulePieceName] = useState("")
    const [rulePieceDescription, setRulePieceDescription] = useState("")
    const [step, setStep] = useState(events ? steps[1] : steps[0])

    const valdateFirstStep = () => {
        return rulePieceName.length > 0 && rulePieceDescription.length > 0
    }

    const [eventTypes, dispatchEventTypes] = useReducer(dataFetchReducer, {
        fetchedData: [null],
        isLoading: true,
        isError: false,
    });

    const [selectedEventTypes, setSelectedEventTypes] = useState([])
    const [availableEventTypes, setAvailableEventTypes] = useState([])

    const mapCompanieName = (companyKey) => {
        return companies.find(c => c.company_key === companyKey).name
    }

    const validateSecondStep = () => {
        if (selectedEventTypes) {
            if (!user_data.business_group_key) {
                return selectedEventTypes.length > 0
            } else {
                let selectedCompanyEventTypes = []

                selectedEventTypes.forEach((et) => {
                    et.companies.filter(company => company.checked).forEach(company => {
                        selectedCompanyEventTypes.push({
                            'event_type': et.enum,
                            'company_key': company.company_key
                        })
                    })
                })
                return selectedCompanyEventTypes.length > 0
            }
        } else {
            return false
        }
    }

    const selectEventType = (eventType) => {
        if (!user_data.business_group_key) {
            setSelectedEventTypes((prev) => [...prev, eventType]);
            setAvailableEventTypes((prev) =>
                prev.filter((et) => et.enum !== eventType.enum)
            );
        } else {
            if ((eventType.companies.filter((comp) => comp.checked) || []).length > 0) {
                setSelectedEventTypes((prev) => [...prev, eventType]);
                setAvailableEventTypes((prev) =>
                    prev.filter((et) => et.enum !== eventType.enum)
                );
            }
        }
    };

    const removeEventType = (eventType) => {
        setAvailableEventTypes((prev) => [...prev, eventType]);

        setSelectedEventTypes((prev) =>
            prev.filter((et) => et.enum !== eventType.enum)
        );
    }

    const toggleEventTypeCollapse = (listType, eventType) => {
        if (listType === 'available') {
            setAvailableEventTypes((prev) => prev.map((et) =>
                et.enum === eventType.enum ? { ...et, collapsed: !et.collapsed } : et
            ))
        } else if (listType === 'selected') {
            setSelectedEventTypes((prev) => prev.map((et) =>
                et.enum === eventType.enum ? { ...et, collapsed: !et.collapsed } : et
            ))
        }
    };

    const isAllCompanySelected = (listType, eventType) => {
        if (listType === 'available') {
            return availableEventTypes.find(et => et.enum === eventType.enum)?.companies.length === availableEventTypes.find(et => et.enum === eventType.enum).companies.filter(company => company.checked).length
        } else if (listType === 'selected') {
            return selectedEventTypes.find(et => et.enum === eventType.enum)?.companies.length === selectedEventTypes.find(et => et.enum === eventType.enum).companies.filter(company => company.checked).length
        }
    };

    const handleSelectAllCompanies = (listType, eventType) => {
        if (listType === 'available') {
            let checkedCompanies = availableEventTypes.find(et => et.enum === eventType.enum).companies.filter(company => company.checked).length

            if (checkedCompanies > 0) {
                setAvailableEventTypes((prev) => prev.map((et) =>
                    et.enum === eventType.enum ? {
                        ...et,
                        companies: availableEventTypes.find(et => et.enum === eventType.enum).companies.map(company => ({ ...company, checked: false }))
                    }
                        : et
                ))
            } else {
                setAvailableEventTypes((prev) => prev.map((et) =>
                    et.enum === eventType.enum ? {
                        ...et,
                        companies: availableEventTypes.find(et => et.enum === eventType.enum).companies.map(company => ({ ...company, checked: true }))
                    }
                        : et
                ))
            }
        } else if (listType === 'selected') {
            let checkedCompanies = selectedEventTypes.find(et => et.enum === eventType.enum).companies.filter(company => company.checked).length

            if (checkedCompanies > 0) {
                setSelectedEventTypes((prev) => prev.map((et) =>
                    et.enum === eventType.enum ? {
                        ...et,
                        companies: selectedEventTypes.find(et => et.enum === eventType.enum).companies.map(company => ({ ...company, checked: false }))
                    }
                        : et
                ))
            } else {
                setSelectedEventTypes((prev) => prev.map((et) =>
                    et.enum === eventType.enum ? {
                        ...et,
                        companies: selectedEventTypes.find(et => et.enum === eventType.enum).companies.map(company => ({ ...company, checked: true }))
                    }
                        : et
                ))
            }
        }
    };

    const toggleCompanySelection = (listType, eventType, companyKey) => {
        if (listType === 'available') {
            setAvailableEventTypes(prev => prev.map(et =>
                et.enum === eventType.enum
                    ? {
                        ...et,
                        companies: et.companies.map(company =>
                            company.company_key === companyKey
                                ? { ...company, checked: !company.checked }
                                : company
                        )
                    }
                    : et
            ));
        } else if (listType === 'selected') {
            setSelectedEventTypes(prev => prev.map(et =>
                et.enum === eventType.enum
                    ? {
                        ...et,
                        companies: et.companies.map(company =>
                            company.company_key === companyKey
                                ? { ...company, checked: !company.checked }
                                : company
                        )
                    }
                    : et
            ));
        }
    };

    useEffect(() => {
        dispatchEventTypes({ type: "data_fetch_init" });
        const timer = setTimeout(() => {
            axios
                .get("/dash/rule_engine/rule_piece/event_types")
                .then((response) => {
                    dispatchEventTypes({
                        type: "data_fetch_success",
                        payload: response.data,
                    });

                    let formattedAvailableEventTypes = []
                    if (!user_data.business_group_key) {
                        formattedAvailableEventTypes = response.data.map((et) => ({ enum: et.enum, companies: [], description: et.description, collapsed: false }))
                    } else {
                        response.data.forEach((comp) => {
                            comp.event_types.forEach((comp_et) => {
                                if (formattedAvailableEventTypes.find(et => et.enum === comp_et.enum)) {
                                    formattedAvailableEventTypes.find(et => et.enum === comp_et.enum).companies.push({ company_key: comp.company_key, checked: false })
                                } else {
                                    formattedAvailableEventTypes.push({ enum: comp_et.enum, companies: [{ company_key: comp.company_key, checked: false }], description: comp_et.description, collapsed: false })
                                }
                            })
                        })
                    }

                    setAvailableEventTypes(formattedAvailableEventTypes)
                })
                .catch((error) => {
                    if ((error.response || {}).status === 403)
                        dispatchEventTypes({ type: "data_fetch_failure_403" });
                    else if ((error.response || {}).status === 404)
                        dispatchEventTypes({ type: "data_fetch_failure_404" });
                    else dispatchEventTypes({ type: "data_fetch_failure" });
                });
        }, 500);
        return () => {
            clearTimeout(timer);
        };
    }, [rule_piece_key, user_data.business_group_key]);

    const [rulePiece, dispatchRulePiece] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    });

    useEffect(() => {
        if (rule_piece_key !== 'new_rule_piece') {
            dispatchRulePiece({ type: "data_fetch_init" });
            const timer = setTimeout(() => {
                axios
                    .get(`/dash/rule_engine/rule_piece/${rule_piece_key}`)
                    .then((response) => {
                        dispatchRulePiece({
                            type: "data_fetch_success",
                            payload: response.data,
                        });

                        setRulePieceName(response.data.name)
                        setRulePieceDescription(response.data.description)
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchRulePiece({ type: "data_fetch_failure_403" });
                        else if ((error.response || {}).status === 404)
                            dispatchRulePiece({ type: "data_fetch_failure_404" });
                        else dispatchRulePiece({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [rule_piece_key])

    const verifyAddedCompanyEvents = () => {
        let originalCompanyEvents = rulePiece.fetchedData.company_events
        let addedCompanyEvents = []

        if (!user_data.business_group_key) {
            selectedEventTypes.forEach(eventType => {
                if (!originalCompanyEvents.find(compEvent => compEvent.event_type === eventType.enum)) {
                    addedCompanyEvents.push({ 'event_type': eventType.enum })
                }
            })
        } else {
            selectedEventTypes.forEach(eventType => {
                eventType.companies.filter(company => company.checked).forEach(company => {
                    if (!originalCompanyEvents.find(compEvent => compEvent.event_type === eventType.enum && compEvent.company_key === company.company_key)) {
                        addedCompanyEvents.push({ 'event_type': eventType.enum, 'company_key': company.company_key })
                    }
                })
            })
        }

        return addedCompanyEvents
    }

    const verifyRemovedCompanyEvents = () => {
        let originalCompanyEvents = rulePiece.fetchedData.company_events
        let removedCompanyEvents = []

        if (!user_data.business_group_key) {
            originalCompanyEvents.forEach(compEvent => {
                if (!selectedEventTypes.find(eventType => eventType.enum === compEvent.event_type)) {
                    removedCompanyEvents.push({ 'event_type': compEvent.event_type })
                }
            })
        } else {
            originalCompanyEvents.forEach(compEvent => {
                if (!selectedEventTypes.find(eventType => eventType.enum === compEvent.event_type && eventType.companies.filter(company => company.checked).find(comp => comp.company_key === compEvent.company_key))) {
                    removedCompanyEvents.push({ 'event_type': compEvent.event_type, 'company_key': compEvent.company_key })
                }
            })
        }

        return removedCompanyEvents
    }

    const formatRulePieceDefinition = () => {

        const rulePiecePayload = {
            name: rulePieceName,
            description: rulePieceDescription,
        }

        let formattedCompanyEventsPayloads = []
        if (!user_data.business_group_key) {

            if (rule_piece_key === 'new_rule_piece') {
                formattedCompanyEventsPayloads = selectedEventTypes.map((et) => {
                    return {
                        'event_type': et.enum
                    }
                })
                rulePiecePayload.company_events = formattedCompanyEventsPayloads
            } else {
                let addedCompanyEvents = verifyAddedCompanyEvents()
                let removedCompanyEvents = verifyRemovedCompanyEvents()

                if (addedCompanyEvents.length > 0)
                    rulePiecePayload.added_company_events = addedCompanyEvents
                if (removedCompanyEvents.length > 0)
                    rulePiecePayload.removed_company_events = removedCompanyEvents
            }

        } else {
            if (rule_piece_key === 'new_rule_piece') {
                selectedEventTypes.forEach((eventType) => {
                    eventType.companies.filter(company => company.checked)
                        .forEach(company => {
                            formattedCompanyEventsPayloads.push({
                                'event_type': eventType.enum,
                                'company_key': company.company_key
                            })
                        })
                })
                rulePiecePayload.company_events = formattedCompanyEventsPayloads
            } else {
                let addedCompanyEvents = verifyAddedCompanyEvents()
                let removedCompanyEvents = verifyRemovedCompanyEvents()

                if (addedCompanyEvents.length > 0)
                    rulePiecePayload.added_company_events = addedCompanyEvents
                if (removedCompanyEvents.length > 0)
                    rulePiecePayload.removed_company_events = removedCompanyEvents
            }

        }

        let requestType = ''
        if (rule_piece_key !== 'new_rule_piece') {
            requestType = 'edition'
            if (rulePiecePayload.added_company_events || rulePiecePayload.removed_company_events) {
                handleRulePiece(rulePiecePayload, requestType)
            } else {
                history.push('/rule-piece/' + rule_piece_key)
            }

        } else {
            requestType = 'creation'
            handleRulePiece(rulePiecePayload, requestType)
        }
    }

    const formatRulePieceEventTypes = useCallback((rulePieceCompanyEvents, availableEventTypesSource) => {
        let formattedSelectedEventTypes = []
        if (!user_data.business_group_key) {
            rulePieceCompanyEvents.forEach((companyEvent) => {
                let matched_description = availableEventTypesSource.find(eventType => eventType.enum === companyEvent.event_type) ? availableEventTypesSource.find(eventType => eventType.enum === companyEvent.event_type)?.description : t("error")
                if (!formattedSelectedEventTypes.find(eventType => eventType.enum === companyEvent.event_type)) {
                    formattedSelectedEventTypes.push({ enum: companyEvent.event_type, companies: [], collapsed: false, description: matched_description })
                }
            })
            setSelectedEventTypes(formattedSelectedEventTypes)
            const selectedEnums = formattedSelectedEventTypes.map(et => et.enum);
            const filteredAvailableEventTypes = availableEventTypesSource.filter(et => !selectedEnums.includes(et.enum));
            const formattedAvailableEventTypes = filteredAvailableEventTypes.map((et) => ({ enum: et.enum, companies: [], description: et.description, collapsed: false }))
            setAvailableEventTypes(formattedAvailableEventTypes);
        } else {
            let notGroupedAvailableEventTypes = []
            availableEventTypesSource.forEach((comp) => {
                comp.event_types.forEach((comp_et) => {
                    if (!notGroupedAvailableEventTypes.find(et => et.enum === comp_et.enum)) {
                        notGroupedAvailableEventTypes.push(comp_et)
                    }
                })
            })

            let originalFormattedAvailableEventTypes = []
            availableEventTypesSource.forEach((comp) => {
                comp.event_types.forEach((comp_et) => {
                    if (originalFormattedAvailableEventTypes.find(et => et.enum === comp_et.enum)) {
                        originalFormattedAvailableEventTypes.find(et => et.enum === comp_et.enum).companies.push({ company_key: comp.company_key, checked: false })
                    } else {
                        originalFormattedAvailableEventTypes.push({ enum: comp_et.enum, companies: [{ company_key: comp.company_key, checked: false }], description: comp_et.description, collapsed: false })
                    }
                })
            })

            let selectedCompanyEvent = []
            rulePieceCompanyEvents.forEach((companyEvent) => {
                if (!selectedCompanyEvent.find(event => ((event.event_type === companyEvent.event_type) && (event.company_key === companyEvent.company_key)))) {
                    selectedCompanyEvent.push(companyEvent)
                }
            })

            let selectedEventTypesSource = originalFormattedAvailableEventTypes
                .filter(eventType => selectedCompanyEvent.find((selectedEventType) => selectedEventType.event_type === eventType.enum))

            selectedEventTypesSource = selectedEventTypesSource.map((eventType) => {
                eventType.companies = eventType.companies.map((company) => {
                    const isSelected = selectedCompanyEvent.find((companyEvent) =>
                        companyEvent.company_key === company.company_key &&
                        companyEvent.event_type === eventType.enum
                    );

                    return {
                        ...company,
                        checked: !!isSelected
                    };
                });
                return eventType;
            });
            let resultAvailableEventTypesSource = originalFormattedAvailableEventTypes
                .filter(eventType => !selectedCompanyEvent.find((selectedEventType) => selectedEventType.event_type === eventType.enum))
            setSelectedEventTypes(selectedEventTypesSource)
            setAvailableEventTypes(resultAvailableEventTypesSource);
        }
    }, [user_data.business_group_key, t])

    useEffect(() => {
        if (rulePiece.fetchedData && eventTypes.fetchedData) {
            formatRulePieceEventTypes(rulePiece.fetchedData.company_events, eventTypes.fetchedData)
        }
    }, [rulePiece.fetchedData, eventTypes.fetchedData, formatRulePieceEventTypes])

    const [changesPreview, dispatChangesPreview] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    });

    const [previewDialog, setPreviewDialog] = useState(false)
    const [previewDialogLoading, setPreviewDialogLoading] = useState(false)

    const handlePreviewDialog = () => {
        setPreviewDialog(true)
        setPreviewDialogLoading(true)

        const rulePiecePayload = {}

        let formattedCompanyEventsPayloads = []
        if (!user_data.business_group_key) {
            if (rule_piece_key === 'new_rule_piece') {
                formattedCompanyEventsPayloads = selectedEventTypes.map((et) => {
                    return {
                        'event_type': et.enum
                    }
                })
                rulePiecePayload.company_events = formattedCompanyEventsPayloads
            } else {
                let addedCompanyEvents = verifyAddedCompanyEvents()
                let removedCompanyEvents = verifyRemovedCompanyEvents()

                if (addedCompanyEvents.length > 0)
                    rulePiecePayload.added_company_events = addedCompanyEvents
                if (removedCompanyEvents.length > 0)
                    rulePiecePayload.removed_company_events = removedCompanyEvents
            }
        } else {
            if (rule_piece_key === 'new_rule_piece') {
                selectedEventTypes.forEach((et) => {
                    et.companies.filter(company => company.checked).forEach(company => {
                        formattedCompanyEventsPayloads.push({
                            'event_type': et.enum,
                            'company_key': company.company_key
                        })
                    })
                })
                rulePiecePayload.company_events = formattedCompanyEventsPayloads
            } else {
                let addedCompanyEvents = verifyAddedCompanyEvents()
                let removedCompanyEvents = verifyRemovedCompanyEvents()

                if (addedCompanyEvents.length > 0)
                    rulePiecePayload.added_company_events = addedCompanyEvents
                if (removedCompanyEvents.length > 0)
                    rulePiecePayload.removed_company_events = removedCompanyEvents
            }
        }

        const timer = setTimeout(() => {
            axios
                .post(`/dash/rule_engine/rule_piece/${rule_piece_key}/changes_preview`, rulePiecePayload)
                .then((response) => {
                    dispatChangesPreview({
                        type: "data_fetch_success",
                        payload: response.data,
                    });
                })
                .catch((error) => {
                    if ((error.response || {}).status === 403)
                        dispatChangesPreview({ type: "data_fetch_failure_403" });
                    else if ((error.response || {}).status === 404)
                        dispatChangesPreview({ type: "data_fetch_failure_404" });
                    else dispatChangesPreview({ type: "data_fetch_failure" });
                    dispatChangesPreview({ type: "data_fetch_init" });
                })
                .finally(() => {

                    setPreviewDialogLoading(false)
                })
        }, 500);
        return () => {
            clearTimeout(timer);
        };
    }


    const [activeRuleBatchChangeDialog, setActiveRuleBatchChangeDialog] = useState(false)

    const handleActiveRuleBatchChangesDialog = () => {
        setActiveRuleBatchChangeDialog(true)
    }

    const mapErrorMessage = (errorCode) => {
        switch (errorCode) {
            case 400:
                return t('rule_piece_error_message_400')
            case 403:
                return t('rule_piece_error_message_403')
            case 404:
                return t('rule_piece_error_message_404')
            case 409:
                return t('rule_piece_error_message_409')
            default:
                return t('default_rule_piece_error_message')
        }
    }

    if (!companies)
        return <div style={{ width: "auto" }}>
            <div className='circularProgressCenter'>
                <CircularProgress />
            </div>
        </div>

    return (
        <>
            <Dialog
                open={props.open}
                onClose={handleDialogClose}
                disableEscapeKeyDown
                keepMounted={false}
                maxWidth={maxWidthEnum}
                fullWidth={true}
            >
                <DialogTitle
                    className={['blueText', "subtitleSize"].join(" ")}
                    onClose={handleDialogClose}
                >
                    {t("Novo Trecho")}
                    <p style={{ marginTop: '10px' }} className={["blueText", "normalMediumSize2"].join(" ")}>
                        {t("step")}: {t(step)}
                    </p>
                </DialogTitle>
                <DialogContent >
                    <div style={{ padding: "10px 20px", display: "flex", flexDirection: "column", marginBottom: "10px" }}>
                        {
                            step === "rule_piece_initial_data" &&
                            <>
                                <div className="smallerInternalCardContainer">
                                    <TextField
                                        error={!rulePieceName.length > 0}
                                        label={t("Nome do Trecho")}
                                        style={{ textAlign: "center" }}
                                        className="filterTextbox"
                                        size="small" fullWidth
                                        value={rulePieceName}
                                        onChange={(e) => setRulePieceName(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                                <div className="smallerInternalCardContainer">
                                    <TextField
                                        error={!rulePieceDescription.length > 0}
                                        label={t("Descrição do Trecho")}
                                        style={{ textAlign: "center" }}
                                        className="filterTextbox"
                                        size="small" fullWidth
                                        value={rulePieceDescription}
                                        onChange={(e) => setRulePieceDescription(e.target.value)}
                                    />
                                </div>
                                <div className="internalCardContainer" style={{ display: "flex", marginTop: "30px", marginLeft: "auto", marginRight: "auto" }}>
                                    <div
                                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "120px" }}
                                        onClick={handleDialogClose}
                                    >
                                        {t("discard")}
                                    </div>
                                    <div
                                        className={
                                            valdateFirstStep()
                                                ?
                                                ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                                :
                                                ["button", "standard", "normalText", "normalMediumSize", "disabled"].join(" ")}
                                        style={{ width: "120px" }}
                                        onClick={valdateFirstStep() ? () => {
                                            setStep(steps[1])
                                            setMaxWidthEnum("lg")
                                            setRulePieceDefinition({
                                                rule_piece_key: rule_piece_key,
                                                user_variables: [],
                                                tree_data: [],
                                                name: rulePieceName,
                                                description: rulePieceDescription
                                            })
                                        } : null}
                                    >
                                        {t("continue")}
                                    </div>
                                </div>
                            </>
                        }
                        {
                            ((step === "rule_piece_company_events_selection" && !events) || (step === "rule_piece_company_events_selection" && events && rulePiece.fetchedData && eventTypes.fetchedData)) &&
                            <>
                                <div className="internalCardContainer" style={{ display: "flex", marginTop: "30px", marginLeft: "auto", marginRight: "auto" }}>
                                    <div
                                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "120px", alignItems:'center', display: 'flex', justifyContent:'center'}}
                                        onClick={handleDialogClose}
                                    >
                                        {t("discard")}
                                    </div>
                                    <div
                                        className={
                                            validateSecondStep()
                                                ?
                                                ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                                :
                                                ["button", "standard", "normalText", "normalMediumSize", "disabled"].join(" ")}
                                        style={{ width: "120px", alignItems:'center', display: 'flex', justifyContent:'center' }}
                                        onClick={validateSecondStep() ? () => {
                                            setMaxWidthEnum('xs')
                                            setStep(steps[2])
                                            formatRulePieceDefinition()
                                        } : null}
                                    >
                                        {t("continue")}
                                    </div>
                                    {(step === "rule_piece_company_events_selection" && events && rulePiece.fetchedData) &&
                                        <>
                                            <div
                                                className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                                style={{ width: "200px", alignItems:'center', display: 'flex', justifyContent:'center' }}
                                                onClick={handlePreviewDialog}
                                            >
                                                {t("preview")}
                                            </div>
                                            {
                                                roles.includes('rule_piece_batch_editor') && 
                                                <div
                                                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                                    style={{ width: "200px", alignItems:'center', display: 'flex', justifyContent:'center' }}
                                                    onClick={handleActiveRuleBatchChangesDialog}
                                                >
                                                    {t("add_in_all_active_rules")}
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                                {
                                    !user_data.business_group_key
                                        ?
                                        <>
                                            <div style={{ margin: '20px' }}>
                                                <div style={{ marginBottom: '20px' }}>
                                                    <p className={["blueText", "normalMediumSize3"].join(" ")}>
                                                        {t("Eventos selecionados")}
                                                    </p>
                                                </div>
                                                <Grid style={{ backgroundColor: '#e5e5e5', padding: '20px', borderRadius: '10px' }} container spacing={2}>
                                                    {
                                                        selectedEventTypes.length > 0 && selectedEventTypes
                                                            .sort((a, b) => a.description.localeCompare(b.description))
                                                            .map((eventType, index) => (
                                                                <Grid item xs={12} sm={6} md={4} key={index}>
                                                                    <Card style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                        <CardContent style={{ padding: 'auto 0' }}>
                                                                            <Typography variant="body2">
                                                                                {eventType.description}
                                                                            </Typography>
                                                                        </CardContent>
                                                                        <CardActions>
                                                                            <IconButton aria-label="close" className={['blueText', "subtitleSize"].join(" ")}
                                                                                onClick={() => removeEventType(eventType)}
                                                                            >
                                                                                <CloseIcon />
                                                                            </IconButton>
                                                                        </CardActions>
                                                                    </Card>
                                                                </Grid>
                                                            ))
                                                    }
                                                </Grid>
                                            </div>
                                            <div style={{ margin: '20px' }}>
                                                <div style={{ marginBottom: '20px' }}>
                                                    <p className={["blueText", "normalMediumSize3"].join(" ")}>
                                                        {t("Eventos disponíveis")}
                                                    </p>
                                                </div>
                                                <Grid style={{ backgroundColor: '#e5e5e5', padding: '20px', borderRadius: '10px' }} container spacing={2}>
                                                    {
                                                        availableEventTypes.length > 0 && availableEventTypes
                                                            .sort((a, b) => a.description.localeCompare(b.description))
                                                            .map((eventType, index) => (
                                                                <Grid item xs={12} sm={6} md={4} key={index}>
                                                                    <Card style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                        <CardContent>
                                                                            <Typography variant="body2">
                                                                                {eventType.description}
                                                                            </Typography>
                                                                        </CardContent>
                                                                        <CardActions>
                                                                            <IconButton aria-label="close" className={['blueText', "subtitleSize"].join(" ")}
                                                                                onClick={() => selectEventType(eventType)}
                                                                            >
                                                                                <AddIcon />
                                                                            </IconButton>
                                                                        </CardActions>
                                                                    </Card>
                                                                </Grid>
                                                            ))
                                                    }
                                                </Grid>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div style={{ margin: '20px' }}>
                                                <div style={{ marginBottom: '20px' }}>
                                                    <p className={["blueText", "normalMediumSize3"].join(" ")}>
                                                        {t("Eventos selecionados")}
                                                    </p>
                                                </div>
                                                <Grid style={{ backgroundColor: '#e5e5e5', padding: '20px', borderRadius: '10px' }} container spacing={2}>
                                                    {
                                                        selectedEventTypes.length > 0 && selectedEventTypes
                                                            .sort((a, b) => a.description.localeCompare(b.description))
                                                            .map((eventType, index) => {
                                                                return (
                                                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                                                        <Card>
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                <CardContent style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <Typography variant="body2">
                                                                                        <strong style={{ color: '#0b1f82' }}>{eventType.description}</strong>
                                                                                    </Typography>
                                                                                </CardContent>
                                                                                <CardActions>
                                                                                    <Button
                                                                                        onClick={() => toggleEventTypeCollapse('selected', eventType)}
                                                                                        size="small"
                                                                                    >
                                                                                        {eventType.collapsed ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                                                                                    </Button>
                                                                                    <IconButton aria-label="close" className={['blueText', "subtitleSize"].join(" ")}
                                                                                        onClick={() => removeEventType(eventType)}
                                                                                    >
                                                                                        <CloseIcon />
                                                                                    </IconButton>
                                                                                </CardActions>
                                                                            </div>
                                                                            <Collapse in={eventType.collapsed} timeout="auto" unmountOnExit>
                                                                                <FormGroup style={{ padding: '0 16px 16px' }}>
                                                                                    <FormControlLabel
                                                                                        control={
                                                                                            <Checkbox
                                                                                                checked={isAllCompanySelected('selected', eventType)}
                                                                                                onChange={() => handleSelectAllCompanies('selected', eventType)}
                                                                                                classes={{
                                                                                                    root: classes.root,
                                                                                                    checked: classes.checked,
                                                                                                }}

                                                                                            />
                                                                                        }
                                                                                        label={t("Selecionar todas")}
                                                                                    />
                                                                                    {
                                                                                        eventType.companies.map((company, idx) => (
                                                                                            <FormControlLabel
                                                                                                key={idx}
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={company.checked}
                                                                                                        onChange={() => toggleCompanySelection('selected', eventType, company.company_key)}
                                                                                                        classes={{
                                                                                                            root: classes.root,
                                                                                                            checked: classes.checked,
                                                                                                        }}
                                                                                                    />
                                                                                                }
                                                                                                label={mapCompanieName(company.company_key)}
                                                                                            />
                                                                                        ))
                                                                                    }
                                                                                </FormGroup>
                                                                            </Collapse>
                                                                        </Card>
                                                                    </Grid>
                                                                )
                                                            }
                                                            )
                                                    }
                                                </Grid>
                                            </div>
                                            <div style={{ margin: '20px' }}>
                                                <div style={{ marginBottom: '20px' }}>
                                                    <p className={["blueText", "normalMediumSize3"].join(" ")}>
                                                        {t("Eventos disponíveis")}
                                                    </p>
                                                </div>
                                                <Grid style={{ backgroundColor: '#e5e5e5', padding: '20px', borderRadius: '10px' }} container spacing={2}>
                                                    {
                                                        availableEventTypes.length > 0 && availableEventTypes
                                                            .sort((a, b) => a.description.localeCompare(b.description))
                                                            .map((eventType, index) => {
                                                                return (
                                                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                                                        <Card>
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                <CardContent style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <Typography variant="body2" >
                                                                                        <strong style={{ color: '#0b1f82' }}>{eventType.description}</strong>
                                                                                    </Typography>
                                                                                </CardContent>
                                                                                <CardActions>
                                                                                    <Button
                                                                                        onClick={() => toggleEventTypeCollapse('available', eventType)}
                                                                                        size="small"
                                                                                    >
                                                                                        {eventType.collapsed ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                                                                                    </Button>
                                                                                    <IconButton aria-label="close" className={['blueText', "subtitleSize"].join(" ")}
                                                                                        onClick={() => selectEventType(eventType)}
                                                                                    >
                                                                                        <AddIcon />
                                                                                    </IconButton>
                                                                                </CardActions>
                                                                            </div>

                                                                            <Collapse in={eventType.collapsed} timeout="auto" unmountOnExit>
                                                                                <FormGroup style={{ padding: '0 16px 16px' }}>
                                                                                    <FormControlLabel
                                                                                        control={
                                                                                            <Checkbox
                                                                                                checked={isAllCompanySelected('available', eventType)}
                                                                                                onChange={() => handleSelectAllCompanies('available', eventType)}
                                                                                                classes={{
                                                                                                    root: classes.root,
                                                                                                    checked: classes.checked,
                                                                                                }}
                                                                                            />
                                                                                        }
                                                                                        label={t("Selecionar todas")}
                                                                                    />
                                                                                    {
                                                                                        eventType.companies.map((company, idx) => (
                                                                                            <FormControlLabel
                                                                                                key={idx}
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={company.checked}
                                                                                                        onChange={() => toggleCompanySelection('available', eventType, company.company_key)}
                                                                                                        classes={{
                                                                                                            root: classes.root,
                                                                                                            checked: classes.checked,
                                                                                                        }}
                                                                                                    />
                                                                                                }
                                                                                                label={mapCompanieName(company.company_key)}
                                                                                            />
                                                                                        ))
                                                                                    }
                                                                                </FormGroup>
                                                                            </Collapse>
                                                                        </Card>
                                                                    </Grid>
                                                                )
                                                            })
                                                    }
                                                </Grid>
                                            </div>
                                        </>
                                }
                            </>
                        }
                        {
                            step === "rule_piece_validation" &&
                            <>
                                <div style={{ margin: '20px' }}>
                                    <div className="smallerInternalCardContainer">
                                        {
                                            !rulePieceErrorCode && <>
                                                <div style={{ width: "auto" }}>
                                                    <div className='circularProgressCenter'>
                                                        <CircularProgress />
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: '20px' }}>
                                                    <Typography variant="body1">
                                                        {t('waiting_rule_piece_creation_message')}
                                                    </Typography>
                                                </div>
                                            </>
                                        }
                                        {
                                            rulePieceErrorCode && <>
                                                <div style={{ width: "auto" }}>
                                                    <div className='circularProgressCenter'>
                                                        <ClearIcon className="fraudStatusIcon" style={{ color: '#D91A1A', width: "40px", height: "40px" }} />
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: '20px' }}>
                                                    <Typography variant="body1">
                                                        {mapErrorMessage(rulePieceErrorCode)}
                                                    </Typography>
                                                </div>
                                                <div>
                                                    <div
                                                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                                        style={{ width: "200px", margin: "30px auto 0px auto" }}
                                                        onClick={() => {
                                                            setStep(steps[1])
                                                            setMaxWidthEnum("lg")
                                                            setRulePieceErrorCode(null)
                                                        }}
                                                    >
                                                        {t("return")}
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </DialogContent>
            </Dialog>
            <ChangesPreviewDialog
                open={previewDialog}
                onClose={() => setPreviewDialog(false)}
                loading={previewDialogLoading}
                changesPreview={changesPreview.fetchedData}
            />
            <ActiveRuleBatchChangeDialog
                open={activeRuleBatchChangeDialog}
                onClose={() => setActiveRuleBatchChangeDialog(false)}
                selectedEventTypes={selectedEventTypes}
                user_data={user_data}
                rule_piece_key={rule_piece_key}
            />
        </>
    )
}

export default NewRulePieceDialog;

